import React from "react";
import PublicHeader from "./PublicHeader";

export default function Help() {

  const DOCS_BASE =
    process.env.REACT_APP_DOCS_BASE_URL || "https://zab-ai.helpscoutdocs.com";

  const openDocs = () => {
    window.open(DOCS_BASE, "_blank", "noopener,noreferrer");
  };


  return (
    <>
      <PublicHeader hideWhenAuthenticated />

      {/* Page content — always render */}
      <div className="max-w-2xl mx-auto bg-white rounded-lg shadow p-6">
        <img src="/help.png" alt="Help" className="w-[90px] h-auto rounded-md mb-4" />
        <h2 className="text-xl font-semibold mb-2">Help Center</h2>
        <p className="text-sm text-gray-700 mb-6">
          Visit our knowledge base for guides, FAQs, and troubleshooting.
        </p>

        <button
          type="button"
          onClick={openDocs}
          className="px-4 py-2 rounded-md text-white hover:opacity-90"
          style={{ backgroundColor: "#00a7e1" }}
        >
          Open Knowledge Base
        </button>
      </div>
    </>
  );
}
